import "../../../assets/presentation/components/not-found/not-found-B7parYjP.css";
import { RoundedButton } from "../controls/button/button2.js";
import { ButtonLabel } from "../controls/button/button-label2.js";
import { CountryCode } from "../../../domain/i18n/country-code.js";
import { useCountry } from "../../hooks/use-country.js";
import { usePaths } from "../../hooks/use-paths.js";
import { Article, Main } from "../layout/layout.js";
import { TopBar } from "../layout/top-bar/top-bar2.js";
import flying_money_do_default from "../../../assets/animations/flying-money-do.js";
import flying_money_gt_default from "../../../assets/animations/flying-money-gt.js";
import flying_money_hn_default from "../../../assets/animations/flying-money-hn.js";
import { ViewPort } from "../view-port/view-port2.js";
/* empty css          */
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { jsx, jsxs } from "react/jsx-runtime";
import { useLottie } from "lottie-react";
//#region src/presentation/components/not-found/not-found.tsx
var NotFound = () => {
	const [, countryCode] = useCountry();
	const { t } = useTranslation("not-found");
	const paths = usePaths();
	const navigate = useNavigate();
	const getAnimationData = () => {
		switch (countryCode) {
			case CountryCode.GT: return flying_money_gt_default;
			case CountryCode.DO: return flying_money_do_default;
			case CountryCode.HN: return flying_money_hn_default;
			default: return flying_money_gt_default;
		}
	};
	const { View: FlyingAnimation } = useLottie({
		animationData: getAnimationData(),
		loop: true,
		autoplay: true
	});
	const onGoToTheStartClick = () => {
		navigate(paths?.home?.HOME);
	};
	return /* @__PURE__ */ jsxs(ViewPort, {
		className: "not-found",
		children: [/* @__PURE__ */ jsx(TopBar, {}), /* @__PURE__ */ jsx(Main, { children: /* @__PURE__ */ jsxs(Article, { children: [
			/* @__PURE__ */ jsx("div", {
				className: "flying-animation",
				children: FlyingAnimation
			}),
			/* @__PURE__ */ jsx("h1", { children: t("this_page_went_flying") }),
			/* @__PURE__ */ jsx("p", { children: t("like_the_middle_payment") }),
			/* @__PURE__ */ jsx(RoundedButton, {
				maxRounded: true,
				onClick: onGoToTheStartClick,
				children: /* @__PURE__ */ jsx(ButtonLabel, { children: t("go_to_the_start") })
			})
		] }) })]
	});
};
//#endregion
export { NotFound };

//# sourceMappingURL=not-found2.js.map